
import Vue from 'vue';
import FormTreeSelect from '~shared/components/commons/FormTreeSelect.vue';
import gql from 'graphql-tag';
import { Campaign } from '~/shared/types/api';

interface IData {
  campaign: Campaign | null;
}

interface INode {
  id: string;
  label?: string | null;
  type: string;
  children?: any[];
}

export default Vue.extend({
  components: {
    FormTreeSelect,
  },
  props: {
    campaignId: {
      type: String,
    },
    creativeAdId: {
      type: String,
      default: ''
    },
    level: {
      type: String,
    },
    includeArchivedAdSets: {
      type: Boolean,
      default: false,
    },
  },
  data(): IData {
    return {
      campaign: null,
    };
  },
  computed: {
    value(): any[] {
      return this.$store.state['advertiser-insights'].filters.selectedChildIds;
    },
    placeholder(): string {
      return this.level === 'ad' ? 'All ads' : 'All ad sets';
    },
    options(): INode[] {
      const allAdSets = {
        id: 'all',
        label: this.level === 'ad' ? 'All ads' : 'All ad sets',
        children: [] as any[],
        type: 'adset',
      };

      if (
        !this.campaign ||
        !this.campaign.adSets ||
        !Array.isArray(this.campaign.adSets.adSets)
      ) {
        return [allAdSets];
      }

      const adSets = this.campaign.adSets.adSets.reduce(
        (accAdSets: INode[], currAdSet) => {
          const adSet: INode = {
            id: currAdSet.id,
            label: currAdSet.name,
            type: 'adset',
          };

          if (
            this.level === 'ad' &&
            currAdSet.ads &&
            Array.isArray(currAdSet.ads.ads)
          ) {
            const ads = currAdSet.ads.ads.reduce(
              (accAds: INode[], currAd) => {
                const ad = {
                  id: currAd.id,
                  label: currAd.title,
                  imageUrl: currAd.imageUrl,
                  type: 'ad',
                };

                accAds.push(ad);
                return accAds;
              },
              [] as any[]
            );
            adSet.children = ads;
          }

          accAdSets.push(adSet);
          return accAdSets;
        },
        []
      );

      allAdSets.children = adSets;
      return [allAdSets];
    },
  },

  methods: {
    limitText(count): string {
      return `+${count} selected`;
    },
    setValues(val: string[]): void {
      // remove the route if there
      const currentQuery = { ...this.$route.query };
      delete currentQuery.creativeAdId;
      this.$router.replace({ path: this.$route.path, query: currentQuery });

      this.$store.dispatch('advertiser-insights/setSelectedChildIds', val);
    },
  },
  apollo: {
    campaign: {
      query: gql`
        query($id: ID!, $statuses: [Status!]) {
          Campaign(id: $id) {
            id
            adSets(statuses: $statuses) {
              adSets {
                id
                name
                ads {
                  ads {
                    id
                    title
                    imageUrl
                  }
                }
              }
            }
          }
        }
      `,
      variables(): { id: string; statuses: string[]; } {
        const statuses = ['ACTIVE', 'PENDING', 'INACTIVE'];
        if (this.includeArchivedAdSets) {
          statuses.push('ARCHIVED');
        }
        return {
          id: this.campaignId,
          statuses,
        };
      },
      update(res): [any] | void {
        if (
          res &&
          res.Campaign &&
          res.Campaign.adSets &&
          Array.isArray(res.Campaign.adSets.adSets)
        ) {
          return res.Campaign;
        }
        return;
      },
      fetchPolicy: 'network-only',
      skip(): boolean {
        return !this.campaignId;
      },
    },
  },
});
